export default __webpack_public_path__ + "static/media/1.944050e7.png";